import { useTranslation } from "react-i18next";
import "./index.css";
import { Typography } from "antd";
import { useEffect, useState } from "react";
import { Card, CardBody, Col, Row, Container } from "reactstrap";

// Swiper
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { selectorChatId } from "../../../redux/chatSlice";
import { actionFetchProjectById, selectorProjectById } from "../../../redux/projectSlice";
import { HistoricContainer2, MainMessagesContainer2 } from "../CompleteChat/styled";
import { MessageList } from "../MessageList";
import { IMessage } from "../types";

interface IUserData {
  name: string;
  role: string;
  picture: string;
}

const EmptyState = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const selectedChat = useAppSelector(selectorChatId);
  const selectedProject = useAppSelector(selectorProjectById);
  const [name, setName] = useState("");
  const [messageList, setMessageList] = useState<IMessage[]>([]);

  function formatName(name: string): string {
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const milliseconds = String(now.getMilliseconds()).padStart(3, "0");
    const timezoneOffset = -now.getTimezoneOffset();
    const sign = timezoneOffset >= 0 ? "+" : "-";
    const offsetHours = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, "0");
    const offsetMinutes = String(Math.abs(timezoneOffset) % 60).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}${sign}${offsetHours}:${offsetMinutes}`;
  };

  useEffect(() => {
    const sessionData = localStorage.getItem("userData");
    if (sessionData) {
      try {
        const dados: IUserData = JSON.parse(sessionData);
        const formattedName = formatName(dados.name);
        setName(formattedName.split(" ")[0]);
      } catch (e) {
        console.error("Erro ao converter os dados:", e);
      }
    }
  }, []);

  useEffect(() => {
    if (selectedProject) {
      setMessageList([
        {
          date_time: getCurrentDateTime(),
          role: "assistant",
          content: selectedProject.welcome_message,
        },
      ]);
    }
  }, [selectedProject]);

  useEffect(() => {
    if (selectedChat?.emptyChat) {
      dispatch(actionFetchProjectById(selectedChat.selectedChatId as number));
    }
  }, [selectedChat]);

  return (
    <>
      {selectedChat?.firstOpenedChat == false && selectedProject ? (
        <HistoricContainer2>
          <MainMessagesContainer2>
            <MessageList messages={messageList} />
          </MainMessagesContainer2>
        </HistoricContainer2>
      ) : (
        <div className="emptyStateContainer">
          <Container fluid>
            <Row>
              <Col lg={12}>
                <Card style={{ boxShadow: "none" }}>
                  <CardBody>
                    <div className="emptyTextContainer">
                      <Typography className="title">
                        {t("pages.home.emptyState.title", { name: name })}
                      </Typography>
                      <Typography className="message">
                        {t("pages.home.emptyState.message")}
                      </Typography>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default EmptyState;
